import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            焦点专题 · 编辑精选
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            编辑团队为你精心策划的影视专题，深度解读最新电影在线看和热门电视剧全集
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-7xl mx-auto">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="relative rounded-lg overflow-hidden group cursor-pointer h-[340px]"
            >
              <img
                src={item.image}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).style.display = 'none';
                }}
              />
              <div className={`absolute inset-0 bg-gradient-to-t ${item.color}`}></div>
              <div className="absolute inset-0 flex flex-col justify-end p-6">
                <span className="self-start px-3 py-1 text-xs font-semibold bg-background-50/90 text-foreground-900 rounded-full mb-3">
                  {item.tag}
                </span>
                <h3 className="font-heading text-lg text-background-50 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-background-50/80 leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}